import { useState, useEffect } from "react";
import { FaTimes, FaImage, FaVideo, FaFilePdf } from "react-icons/fa";
import "./EditRevolution.css";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

export default function EditRevolution({ onUpdate, onClose, data }) {
  const revolutionID = data?._id;
  const [removeFiles, setRemoveFiles] = useState([]);

  const [images, setImages] = useState([]);
  const [newImages, setNewImages] = useState([]);

  const [videos, setVideos] = useState([]);
  const [newVideos, setNewVideos] = useState([]);

  const [pdfs, setPdfs] = useState([]);
  const [newPdfs, setNewPdfs] = useState([]);

  const [to, setTo] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [visibility, setVisibility] = useState("");
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setImages(data.images || []);
      setVideos(data.videos || []);
      setPdfs(data.pdfs || []);

      setTo(data.to || "");
      setTitle(data.title || "");
      setDescription(data.description || "");
      setVisibility(data.visibility || "");

      setNewImages([]);
      setNewVideos([]);
      setNewPdfs([]);
    }
  }, [data]);

  const removeImage = (index, type) => {
    if (type === "old") {
      const fileToRemove = images[index];
      setRemoveFiles((prev) => [...prev, fileToRemove]);
      setImages(images.filter((_, i) => i !== index));
    } else {
      setNewImages(newImages.filter((_, i) => i !== index));
    }
  };

  // const removeImage = (index, type) => {
  //   if (type === "old") {
  //     setImages(images.filter((_, i) => i !== index));
  //   } else {
  //     setNewImages(newImages.filter((_, i) => i !== index));
  //   }
  // };

  const removeVideo = (index, type) => {
    if (type === "old") {
      const fileToRemove = videos[index];
      setRemoveFiles((prev) => [...prev, fileToRemove]);
      setVideos(videos.filter((_, i) => i !== index));
    } else {
      setNewVideos(newVideos.filter((_, i) => i !== index));
    }
  };

  const removePdf = (index, type) => {
    if (type === "old") {
      const fileToRemove = pdfs[index];
      setRemoveFiles((prev) => [...prev, fileToRemove]);
      setPdfs(pdfs.filter((_, i) => i !== index));
    } else {
      setNewPdfs(newPdfs.filter((_, i) => i !== index));
    }
  };

  const addImages = (e) => {
    const files = Array.from(e.target.files);
    console.log("Selected files: ", files);

    setNewImages((prev) => [
      ...prev,
      ...files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      })),
    ]);
  };

  const addVideos = (e) => {
    const files = Array.from(e.target.files);

    if (videos.length + newVideos.length + files.length > 2) {
      toast.warning(
        "You can upload maximum 2 videos. Remove one to add another.",
      );
      return;
    }

    setNewVideos((prev) => [
      ...prev,
      ...files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      })),
    ]);
  };

  const addPdfs = (e) => {
    const files = Array.from(e.target.files);

    if (pdfs.length + newPdfs.length + files.length > 2) {
      toast.warning(
        "You can upload maximum 2 PDFs. Remove one to add another.",
      );
      return;
    }

    setNewPdfs((prev) => [
      ...prev,
      ...files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      })),
    ]);
  };

  useEffect(() =>{
    console.log(removeFiles , "removefiles")
  },[removeFiles])

  const handleSaveChanges = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();

      formData.append("title", title);
      formData.append("description", description);
      formData.append("to", to);
      formData.append("visibility", visibility);

      if (removeFiles.length > 0) {
        formData.append("removeFiles", JSON.stringify(removeFiles));
      }

      images.forEach((img) => formData.append("existingImages", img));
      videos.forEach((vid) => formData.append("existingVideos", vid));
      pdfs.forEach((pdf) => formData.append("existingPdfs", pdf));

      newImages.forEach((img) => formData.append("images", img.file));
      newVideos.forEach((vid) => formData.append("videos", vid.file));
      newPdfs.forEach((pdf) => formData.append("pdfs", pdf.file));

      const res = await api.put(`revolution/${revolutionID}`, formData);
      toast.success("Revolution updated successfully");
      onUpdate(res.data.revolution);
      onClose();
    } catch (error) {
      setIsLoading(false);
      console.log("Error saving changes: ", error);
      toast.error("Error updating revolution");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog  revolution_edit_container_section">
        <div className="modal-content">
          <div className="modal-header edit_revolution_header">
            <h5>Edit Revolution</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="visibilty_container">
              <select
                name="visibility"
                value={visibility}
                onChange={(e) => setVisibility(e.target.value)}
              >
                <option value="">Select Visibility</option>
                <option value="NATIONAL">National</option>
                <option value="STATE">State</option>
                <option value="DISTRICT">District</option>
              </select>
            </div>

            <div className="revolution_edit_container">
              <input
                className="form-control mb-2"
                placeholder="To"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />

              <input
                className="form-control mb-2"
                placeholder="Subject"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />

              <textarea
                className="form-control mb-3"
                placeholder="Message"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* IMAGES */}

            {(images.length > 0 || newImages.length > 0) && (
              <div className="media_item">
                <h6>Images</h6>
                <div className="media_grid">
                  {images.map((img, i) => (
                    <div className="media_item" key={i}>
                      <img src={img} alt="" />
                      <button
                        className="remove_btn"
                        onClick={() => removeImage(i, "old")}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}

                  {newImages.map((img, i) => (
                    <div className="media_item" key={i}>
                      <img src={img.preview} alt="" />
                      <button
                        className="remove_btn"
                        onClick={() => removeImage(i, "new")}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* VIDEOS */}
            {(videos.length > 0 || newVideos.length > 0) && (
              <div className="media_item">
                <h6>Videos</h6>
                <div className="media_grid">
                  {videos.map((video, i) => (
                    <div className="media_item" key={i}>
                      <video src={video} controls />
                      <button
                        className="remove_btn"
                        onClick={() => removeVideo(i, "old")}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}

                  {newVideos.map((video, i) => (
                    <div className="media_item" key={i}>
                      <video src={video.preview} controls />
                      <button
                        className="remove_btn"
                        onClick={() => removeVideo(i, "new")}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* PDF */}
            {(pdfs.length > 0 || newPdfs.length > 0) && (
              <div className="media_item">
                <h6>Documents</h6>
                <div className="pdf_container">
                  {pdfs.map((pdf, i) => (
                    <div className="pdf_item" key={i}>
                      <span>
                        PDF {i + 1}
                        <button
                          className=" remove_pdf_btn"
                          onClick={() => removePdf(i, "old")}
                        >
                          <FaTimes />
                        </button>
                      </span>
                    </div>
                  ))}

                  {newPdfs.map((pdf, i) => (
                    <div className="pdf_item" key={i}>
                      <span>
                        PDF {pdf.name} {i + 1}
                        <button
                          // className="remove_btn remove_pdf_btn"
                          className="remove_pdf_btn"
                          onClick={() => removePdf(i, "new")}
                        >
                          <FaTimes />
                        </button>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer edit_revolution_footer">
            <div className="add_media_container">
              <label>
                <FaImage className="media_icon" />
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  hidden
                  onChange={addImages}
                />
              </label>

              <label>
                <FaVideo className="media_icon" />
                <input
                  type="file"
                  accept="video/*"
                  multiple
                  hidden
                  onChange={addVideos}
                />
              </label>

              <label>
                {/* <FaFilePdf className="media_icon" /> */}
                <FontAwesomeIcon icon={faLink} className="media_icon" />
                <input
                  type="file"
                  accept="application/pdf"
                  multiple
                  hidden
                  onChange={addPdfs}
                />
              </label>
            </div>

            <div className="add_btn_container">
              <button className="btn btn-primary" onClick={handleSaveChanges}>
                {isloading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
